export const NOTE_TYPES = [
  "Administrative",
  "Clinical",
  "Communication",
  "Patient concern",
  "Internal reminder",
];

export const NOTE_TYPE_CLASSES = {
  Administrative: "note-administrative",
  Clinical: "note-clinical",
  Communication: "note-communication",
  "Patient concern": "note-patient-concern",
  "Internal reminder": "note-internal-reminder",
};
